import { uploadFilesStepIndex } from "../../Constants/Stepper";
import * as types from "./actionTypes";
import { resetAssetData } from "./assetsAction";
import { setActiveStep } from "./stepperActions";
import { resetSubmittedAssets } from "./submittedActions";
import { resetTagsData } from "./tagActions";

export function dispatchActionData(type, data) {
  return { type: type, data: data };
}

// toggle views between CSV upload and manual entry.
export function toggleCreateAssetView(data) {
  return function (dispatch) {
    // Reset the asset data when view is switched.
    dispatch(resetAssetData());
    //Resetting tags redux state.
    dispatch(resetTagsData());
    //Resetting submitted assets state
    dispatch(resetSubmittedAssets());
    //setting stepper count to 1. which renders initial view
    dispatch(setActiveStep(uploadFilesStepIndex));
    dispatch(dispatchActionData(types.TOGGLE_CREATE_ASSET_MANUALENTRY_CSVUPLOAD_VIEW, data));
  };
}
